var map = {
	"./": "./src/views/index.vue",
	"./Rep": "./src/views/Rep/index.vue",
	"./Rep/": "./src/views/Rep/index.vue",
	"./Rep/index": "./src/views/Rep/index.vue",
	"./Rep/index.vue": "./src/views/Rep/index.vue",
	"./Rep/index111": "./src/views/Rep/index111.vue",
	"./Rep/index111.vue": "./src/views/Rep/index111.vue",
	"./authentication": "./src/views/authentication/index.vue",
	"./authentication/": "./src/views/authentication/index.vue",
	"./authentication/IdentityKYC": "./src/views/authentication/IdentityKYC/index.vue",
	"./authentication/IdentityKYC/": "./src/views/authentication/IdentityKYC/index.vue",
	"./authentication/IdentityKYC/components/CAInfo": "./src/views/authentication/IdentityKYC/components/CAInfo.vue",
	"./authentication/IdentityKYC/components/CAInfo.vue": "./src/views/authentication/IdentityKYC/components/CAInfo.vue",
	"./authentication/IdentityKYC/components/CAPage": "./src/views/authentication/IdentityKYC/components/CAPage.vue",
	"./authentication/IdentityKYC/components/CAPage.vue": "./src/views/authentication/IdentityKYC/components/CAPage.vue",
	"./authentication/IdentityKYC/components/CNInfo": "./src/views/authentication/IdentityKYC/components/CNInfo.vue",
	"./authentication/IdentityKYC/components/CNInfo.vue": "./src/views/authentication/IdentityKYC/components/CNInfo.vue",
	"./authentication/IdentityKYC/components/CNPage": "./src/views/authentication/IdentityKYC/components/CNPage.vue",
	"./authentication/IdentityKYC/components/CNPage.vue": "./src/views/authentication/IdentityKYC/components/CNPage.vue",
	"./authentication/IdentityKYC/components/HKInfo": "./src/views/authentication/IdentityKYC/components/HKInfo.vue",
	"./authentication/IdentityKYC/components/HKInfo.vue": "./src/views/authentication/IdentityKYC/components/HKInfo.vue",
	"./authentication/IdentityKYC/components/HKPage": "./src/views/authentication/IdentityKYC/components/HKPage.vue",
	"./authentication/IdentityKYC/components/HKPage.vue": "./src/views/authentication/IdentityKYC/components/HKPage.vue",
	"./authentication/IdentityKYC/components/USInfo": "./src/views/authentication/IdentityKYC/components/USInfo.vue",
	"./authentication/IdentityKYC/components/USInfo.vue": "./src/views/authentication/IdentityKYC/components/USInfo.vue",
	"./authentication/IdentityKYC/components/USPage": "./src/views/authentication/IdentityKYC/components/USPage.vue",
	"./authentication/IdentityKYC/components/USPage.vue": "./src/views/authentication/IdentityKYC/components/USPage.vue",
	"./authentication/IdentityKYC/index": "./src/views/authentication/IdentityKYC/index.vue",
	"./authentication/IdentityKYC/index.vue": "./src/views/authentication/IdentityKYC/index.vue",
	"./authentication/IdentityKYC/info": "./src/views/authentication/IdentityKYC/info.vue",
	"./authentication/IdentityKYC/info.vue": "./src/views/authentication/IdentityKYC/info.vue",
	"./authentication/approve": "./src/views/authentication/approve/index.vue",
	"./authentication/approve/": "./src/views/authentication/approve/index.vue",
	"./authentication/approve/components/authStatus": "./src/views/authentication/approve/components/authStatus.vue",
	"./authentication/approve/components/authStatus.vue": "./src/views/authentication/approve/components/authStatus.vue",
	"./authentication/approve/components/digital": "./src/views/authentication/approve/components/digital.vue",
	"./authentication/approve/components/digital.vue": "./src/views/authentication/approve/components/digital.vue",
	"./authentication/approve/components/digitalDialog": "./src/views/authentication/approve/components/digitalDialog.vue",
	"./authentication/approve/components/digitalDialog.vue": "./src/views/authentication/approve/components/digitalDialog.vue",
	"./authentication/approve/components/mineral": "./src/views/authentication/approve/components/mineral.vue",
	"./authentication/approve/components/mineral.vue": "./src/views/authentication/approve/components/mineral.vue",
	"./authentication/approve/components/rejectDialog": "./src/views/authentication/approve/components/rejectDialog.vue",
	"./authentication/approve/components/rejectDialog.vue": "./src/views/authentication/approve/components/rejectDialog.vue",
	"./authentication/approve/detail": "./src/views/authentication/approve/detail.vue",
	"./authentication/approve/detail.vue": "./src/views/authentication/approve/detail.vue",
	"./authentication/approve/index": "./src/views/authentication/approve/index.vue",
	"./authentication/approve/index.vue": "./src/views/authentication/approve/index.vue",
	"./authentication/businessKYC": "./src/views/authentication/businessKYC/index.vue",
	"./authentication/businessKYC/": "./src/views/authentication/businessKYC/index.vue",
	"./authentication/businessKYC/components/HKbusinessKYC": "./src/views/authentication/businessKYC/components/HKbusinessKYC.vue",
	"./authentication/businessKYC/components/HKbusinessKYC.vue": "./src/views/authentication/businessKYC/components/HKbusinessKYC.vue",
	"./authentication/businessKYC/components/HKbusinessKYCInfo": "./src/views/authentication/businessKYC/components/HKbusinessKYCInfo.vue",
	"./authentication/businessKYC/components/HKbusinessKYCInfo.vue": "./src/views/authentication/businessKYC/components/HKbusinessKYCInfo.vue",
	"./authentication/businessKYC/components/OtherBusinessKYC": "./src/views/authentication/businessKYC/components/OtherBusinessKYC.vue",
	"./authentication/businessKYC/components/OtherBusinessKYC.vue": "./src/views/authentication/businessKYC/components/OtherBusinessKYC.vue",
	"./authentication/businessKYC/components/OtherBusinessKYCInfo": "./src/views/authentication/businessKYC/components/OtherBusinessKYCInfo.vue",
	"./authentication/businessKYC/components/OtherBusinessKYCInfo.vue": "./src/views/authentication/businessKYC/components/OtherBusinessKYCInfo.vue",
	"./authentication/businessKYC/index": "./src/views/authentication/businessKYC/index.vue",
	"./authentication/businessKYC/index.vue": "./src/views/authentication/businessKYC/index.vue",
	"./authentication/businessKYC/info": "./src/views/authentication/businessKYC/info.vue",
	"./authentication/businessKYC/info.vue": "./src/views/authentication/businessKYC/info.vue",
	"./authentication/editInformationSuccess": "./src/views/authentication/editInformationSuccess.vue",
	"./authentication/editInformationSuccess.vue": "./src/views/authentication/editInformationSuccess.vue",
	"./authentication/index": "./src/views/authentication/index.vue",
	"./authentication/index.vue": "./src/views/authentication/index.vue",
	"./authentication/init": "./src/views/authentication/init/index.vue",
	"./authentication/init/": "./src/views/authentication/init/index.vue",
	"./authentication/init/index": "./src/views/authentication/init/index.vue",
	"./authentication/init/index.vue": "./src/views/authentication/init/index.vue",
	"./authentication/init/selectAsset/selectAsset": "./src/views/authentication/init/selectAsset/selectAsset.vue",
	"./authentication/init/selectAsset/selectAsset.vue": "./src/views/authentication/init/selectAsset/selectAsset.vue",
	"./authentication/init/successDialog": "./src/views/authentication/init/successDialog.vue",
	"./authentication/init/successDialog.vue": "./src/views/authentication/init/successDialog.vue",
	"./authentication/well": "./src/views/authentication/well.vue",
	"./authentication/well.vue": "./src/views/authentication/well.vue",
	"./components/icons": "./src/views/components/icons/index.vue",
	"./components/icons/": "./src/views/components/icons/index.vue",
	"./components/icons/element-icons": "./src/views/components/icons/element-icons.js",
	"./components/icons/element-icons.js": "./src/views/components/icons/element-icons.js",
	"./components/icons/index": "./src/views/components/icons/index.vue",
	"./components/icons/index.vue": "./src/views/components/icons/index.vue",
	"./components/icons/svg-icons": "./src/views/components/icons/svg-icons.js",
	"./components/icons/svg-icons.js": "./src/views/components/icons/svg-icons.js",
	"./dashboard/BarChart": "./src/views/dashboard/BarChart.vue",
	"./dashboard/BarChart.vue": "./src/views/dashboard/BarChart.vue",
	"./dashboard/LineChart": "./src/views/dashboard/LineChart.vue",
	"./dashboard/LineChart.vue": "./src/views/dashboard/LineChart.vue",
	"./dashboard/LineChart2": "./src/views/dashboard/LineChart2.vue",
	"./dashboard/LineChart2.vue": "./src/views/dashboard/LineChart2.vue",
	"./dashboard/PieChart": "./src/views/dashboard/PieChart.vue",
	"./dashboard/PieChart.vue": "./src/views/dashboard/PieChart.vue",
	"./dashboard/mixins/resize": "./src/views/dashboard/mixins/resize.js",
	"./dashboard/mixins/resize.js": "./src/views/dashboard/mixins/resize.js",
	"./error/401": "./src/views/error/401.vue",
	"./error/401.vue": "./src/views/error/401.vue",
	"./error/404": "./src/views/error/404.vue",
	"./error/404.vue": "./src/views/error/404.vue",
	"./expenseMansgement": "./src/views/expenseMansgement/index.vue",
	"./expenseMansgement/": "./src/views/expenseMansgement/index.vue",
	"./expenseMansgement/index": "./src/views/expenseMansgement/index.vue",
	"./expenseMansgement/index.vue": "./src/views/expenseMansgement/index.vue",
	"./home/homeMessage": "./src/views/home/homeMessage.vue",
	"./home/homeMessage.vue": "./src/views/home/homeMessage.vue",
	"./home/homePercent": "./src/views/home/homePercent.vue",
	"./home/homePercent.vue": "./src/views/home/homePercent.vue",
	"./home/homeTop": "./src/views/home/homeTop.vue",
	"./home/homeTop.vue": "./src/views/home/homeTop.vue",
	"./home/homeTopAuditor": "./src/views/home/homeTopAuditor.vue",
	"./home/homeTopAuditor.vue": "./src/views/home/homeTopAuditor.vue",
	"./index": "./src/views/index.vue",
	"./index.vue": "./src/views/index.vue",
	"./message/list": "./src/views/message/list.vue",
	"./message/list.vue": "./src/views/message/list.vue",
	"./message/send": "./src/views/message/send.vue",
	"./message/send.vue": "./src/views/message/send.vue",
	"./message/updateName": "./src/views/message/updateName.vue",
	"./message/updateName.vue": "./src/views/message/updateName.vue",
	"./redirect": "./src/views/redirect.vue",
	"./redirect.vue": "./src/views/redirect.vue",
	"./securityDeposit": "./src/views/securityDeposit/index.vue",
	"./securityDeposit/": "./src/views/securityDeposit/index.vue",
	"./securityDeposit/index": "./src/views/securityDeposit/index.vue",
	"./securityDeposit/index.vue": "./src/views/securityDeposit/index.vue",
	"./sign": "./src/views/sign/index.vue",
	"./sign/": "./src/views/sign/index.vue",
	"./sign/index": "./src/views/sign/index.vue",
	"./sign/index.vue": "./src/views/sign/index.vue",
	"./sign/mmLogin": "./src/views/sign/mmLogin.vue",
	"./sign/mmLogin.vue": "./src/views/sign/mmLogin.vue",
	"./volumeAudit": "./src/views/volumeAudit/index.vue",
	"./volumeAudit/": "./src/views/volumeAudit/index.vue",
	"./volumeAudit/AuditorPage": "./src/views/volumeAudit/AuditorPage.vue",
	"./volumeAudit/AuditorPage.vue": "./src/views/volumeAudit/AuditorPage.vue",
	"./volumeAudit/ManufacturerPage": "./src/views/volumeAudit/ManufacturerPage.vue",
	"./volumeAudit/ManufacturerPage.vue": "./src/views/volumeAudit/ManufacturerPage.vue",
	"./volumeAudit/index": "./src/views/volumeAudit/index.vue",
	"./volumeAudit/index.vue": "./src/views/volumeAudit/index.vue",
	"./wellManage/addWell/addWell": "./src/views/wellManage/addWell/addWell.vue",
	"./wellManage/addWell/addWell.vue": "./src/views/wellManage/addWell/addWell.vue",
	"./wellManage/annualReview": "./src/views/wellManage/annualReview/index.vue",
	"./wellManage/annualReview/": "./src/views/wellManage/annualReview/index.vue",
	"./wellManage/annualReview/index": "./src/views/wellManage/annualReview/index.vue",
	"./wellManage/annualReview/index.vue": "./src/views/wellManage/annualReview/index.vue",
	"./wellManage/approveAnnual": "./src/views/wellManage/approveAnnual/index.vue",
	"./wellManage/approveAnnual/": "./src/views/wellManage/approveAnnual/index.vue",
	"./wellManage/approveAnnual/details": "./src/views/wellManage/approveAnnual/details.vue",
	"./wellManage/approveAnnual/details.vue": "./src/views/wellManage/approveAnnual/details.vue",
	"./wellManage/approveAnnual/index": "./src/views/wellManage/approveAnnual/index.vue",
	"./wellManage/approveAnnual/index.vue": "./src/views/wellManage/approveAnnual/index.vue",
	"./wellManage/approveWells": "./src/views/wellManage/approveWells/index.vue",
	"./wellManage/approveWells/": "./src/views/wellManage/approveWells/index.vue",
	"./wellManage/approveWells/details": "./src/views/wellManage/approveWells/details.vue",
	"./wellManage/approveWells/details.vue": "./src/views/wellManage/approveWells/details.vue",
	"./wellManage/approveWells/index": "./src/views/wellManage/approveWells/index.vue",
	"./wellManage/approveWells/index.vue": "./src/views/wellManage/approveWells/index.vue",
	"./wellManage/myWells": "./src/views/wellManage/myWells/index.vue",
	"./wellManage/myWells/": "./src/views/wellManage/myWells/index.vue",
	"./wellManage/myWells/AddWellDia": "./src/views/wellManage/myWells/AddWellDia.vue",
	"./wellManage/myWells/AddWellDia.vue": "./src/views/wellManage/myWells/AddWellDia.vue",
	"./wellManage/myWells/ChangeBenefitDia": "./src/views/wellManage/myWells/ChangeBenefitDia.vue",
	"./wellManage/myWells/ChangeBenefitDia.vue": "./src/views/wellManage/myWells/ChangeBenefitDia.vue",
	"./wellManage/myWells/ConnectDAPPDia": "./src/views/wellManage/myWells/ConnectDAPPDia.vue",
	"./wellManage/myWells/ConnectDAPPDia.vue": "./src/views/wellManage/myWells/ConnectDAPPDia.vue",
	"./wellManage/myWells/addWell": "./src/views/wellManage/myWells/addWell.vue",
	"./wellManage/myWells/addWell.vue": "./src/views/wellManage/myWells/addWell.vue",
	"./wellManage/myWells/baseInfo": "./src/views/wellManage/myWells/baseInfo.vue",
	"./wellManage/myWells/baseInfo.vue": "./src/views/wellManage/myWells/baseInfo.vue",
	"./wellManage/myWells/components/share": "./src/views/wellManage/myWells/components/share.vue",
	"./wellManage/myWells/components/share.vue": "./src/views/wellManage/myWells/components/share.vue",
	"./wellManage/myWells/components/well": "./src/views/wellManage/myWells/components/well.vue",
	"./wellManage/myWells/components/well.vue": "./src/views/wellManage/myWells/components/well.vue",
	"./wellManage/myWells/details": "./src/views/wellManage/myWells/details.vue",
	"./wellManage/myWells/details.vue": "./src/views/wellManage/myWells/details.vue",
	"./wellManage/myWells/index": "./src/views/wellManage/myWells/index.vue",
	"./wellManage/myWells/index.vue": "./src/views/wellManage/myWells/index.vue",
	"./wellManage/myWells/modifyPage": "./src/views/wellManage/myWells/modifyPage.vue",
	"./wellManage/myWells/modifyPage.vue": "./src/views/wellManage/myWells/modifyPage.vue",
	"./wellManage/myWells/pointInfo": "./src/views/wellManage/myWells/pointInfo.vue",
	"./wellManage/myWells/pointInfo.vue": "./src/views/wellManage/myWells/pointInfo.vue",
	"./wellManage/myWells/wellInfo": "./src/views/wellManage/myWells/wellInfo.vue",
	"./wellManage/myWells/wellInfo.vue": "./src/views/wellManage/myWells/wellInfo.vue"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/views sync recursive ^\\.\\/.*$";